import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Tooltip } from '@fluentui/react-components';
import { useTrucatedTextStyles } from '../styles';

export const TruncatedText = ({ className, content }) => {
  const styles = useTrucatedTextStyles();

  return (
    <div className={classNames(className, styles.truncatedTextContainer)}>
      <Tooltip content={content} relationship="inaccessible" positioning="below-end">
        <span className="trucated-text">
          {content}
        </span>
      </Tooltip>
    </div>
  );
};

TruncatedText.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TruncatedText.defaultProps = {
  className: '',
};
